import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { DatePickerValue } from '../../../../components/date-picker';
import { useAuthenticatedUser } from '../../../../authentication';
import { format } from 'date-fns';
import { da } from 'date-fns/locale';
import { absenceDay } from './absence-day';

const forumAppAttentionColor = '#F39C11';
const forumAppWarningColor = '#E65100';

export interface IAbsenceStatusBarPreviewProps {
  startDate: DatePickerValue;
  endDate: DatePickerValue;
  text: string;
  caseworkerName?: string;
}

function absencePeriodText(startDate: Exclude<DatePickerValue, undefined>, endDate: DatePickerValue) {
  const start = format(absenceDay(startDate), 'd MMMM yyyy', { locale: da });
  return endDate ? `${start} - ${format(absenceDay(endDate), 'd MMMM', { locale: da })}` : `siden ${start}`;
}

export function AbsenceStatusBarPreview(props: IAbsenceStatusBarPreviewProps) {
  const { startDate, endDate, text } = props;
  const loggedInUserName = useAuthenticatedUser()?.profile.name;
  const caseworkerName = props.caseworkerName || loggedInUserName || 'Sagsbehandleren';

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="subtitle2" component="h3">
        Sådan ser borgeren det
      </Typography>
      {startDate ? (
        <Box role="status" display="flex" alignItems="flex-start" gap={1} px={2} py={1} sx={{ bgcolor: alpha(forumAppAttentionColor, 0.2) }}>
          <Box color={forumAppWarningColor} display="flex" alignItems="center" height="1.5em">
            <FontAwesomeIcon icon={faCircleInfo} />
          </Box>
          <Box>
            <Typography variant="caption" fontWeight={600} display="block">
              Automatisk information
            </Typography>
            <Typography variant="subtitle2" component="p">
              {caseworkerName} er fraværende {absencePeriodText(startDate, endDate)}
            </Typography>
            {text.trim() && <Typography variant="body2">{text.trim()}</Typography>}
          </Box>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Vælg en startdato for at se statusbjælken.
        </Typography>
      )}
    </Box>
  );
}
